import * as React from 'react';
import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsxs(React.Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    fillOpacity: ".3",
    d: "M17 4h-3V2h-4v2H7v4h10V4z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M7 8v14h10V8H7z"
  })]
}), 'Battery90Sharp');